import React from 'react';
import styled from 'styled-components';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import NavLink from '../NavLink';
import * as NavUtil from '../../Utils/NavUtil';
import * as AppActions from './../../AppActions';
import Theme from '../../Theme';
import {Menu as MenuIcon} from '@styled-icons/boxicons-regular/Menu';
import useArea from '../../Hooks/useArea';
import {Link} from 'gatsby';
import {Line} from '@styled-icons/fa-brands/Line';
import {FacebookSquare} from '@styled-icons/fa-brands/FacebookSquare';
import NavBarDrawer from './NavBarDrawer';

const Config = require('../../../data.json');

function NavBar(props) {
  const {location} = props;
  useOutlet('navbarConfig');
  const showLoginModal = useOutletSetter('login-modal');
  const [drawer, setDrawer] = React.useState(false);
  const {area, isPeople, isDoctor} = useArea();
  const navItems = NavUtil.getNavItems({...props, isDoctor});
  const [user] = useOutlet('user');

  React.useEffect(() => {
    setDrawer(false);
  }, [location?.pathname]);

  return (
    <Wrapper>
      {/* main navbar */}
      <div className="container">
        <NavLink to={'/' + area}>
          <div className="logo-box">
            <img
              src="/images/site-logo.png"
              alt="Logo"
              style={{
                width: 50,
              }}
            />
            <div style={{marginLeft: 8}}>
              <div style={{fontSize: 20, color: '#000'}}>
                社團法人台北市牙醫師公會
              </div>
              <div style={{fontSize: 14, color: '#aaa'}}>
                Taipei Dental Association
              </div>
            </div>
          </div>
        </NavLink>
        {isPeople ? (
          <div style={{flex: 1}}>
            <span
              style={{
                color: '#fff',
                backgroundColor: 'var(--primaryColor)',
                padding: '4px 8px',
                marginLeft: 10,
                borderRadius: 4,
              }}>
              民眾專區
            </span>
          </div>
        ) : isDoctor ? (
          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 10,
            }}>
            <Link to="/doctor">首頁</Link>
            {user ? (
              <Link to="/doctor/member">Hi, {user.data?.name}</Link>
            ) : (
              <a
                href="#"
                onClick={() => {
                  showLoginModal(true);
                }}>
                登入
              </a>
            )}
            <Link to="/doctor/contact">聯絡我們</Link>
            <Link to="/doctor/links">相關網站</Link>
            <a
              target="_blank"
              href="https://facebook.com/120275868022597"
              rel="noreferrer">
              <FacebookSquare size={30} color="#1774EB" />
            </a>
            <a
              target="_blank"
              href="http://line.me/ti/p/E3m_fsOMYR"
              rel="noreferrer">
              <Line size={30} color="#02C755" />
            </a>
          </div>
        ) : null}

        {isDoctor ? (
          <Link to="/people" style={{marginLeft: 10}}>
            <img
              src="/images/navigation-people.png"
              alt="navigation-people"
              style={{height: 70}}
            />
          </Link>
        ) : isPeople ? (
          <Link to="/doctor" style={{marginLeft: 10}}>
            <img
              src="/images/navigation-doctor.png"
              alt="navigation-doctor"
              style={{height: 70}}
            />
          </Link>
        ) : null}
      </div>

      {/* mobile */}
      <div className="container-mobile">
        <button className="menu" onClick={() => setDrawer(!drawer)}>
          <MenuIcon size={24} color="#fff" />
        </button>
        <NavLink to={'/' + area} loading={800}>
          <img
            src="/images/logo-border.png"
            alt="Logo"
            style={{
              width: 60,
            }}
          />
        </NavLink>
        <NavLink to={'/' + (isDoctor ? 'people' : 'doctor')} loading={800}>
          <img
            src={
              isDoctor
                ? '/images/nav-mobile-people.png'
                : '/images/nav-mobile-doctor.png'
            }
            alt="Logo"
            style={{
              height: 'var(--topNavBarHeight)',
              objectFit: 'contain',
            }}
          />
        </NavLink>
      </div>

      {/* sub navbar */}
      <div
        className={
          'sub-nav ' + (isDoctor ? 'doctor' : isPeople ? 'people' : '')
        }>
        <ul className="content">
          {navItems.map((navItem, idx) => {
            const selected = NavUtil.isNavLinkSelected(navItem);

            if (navItem.entries) {
              return (
                <DropDown key={idx}>
                  <button
                    className={
                      'nav-item ' +
                      (selected ? ` selected ` : '') +
                      (isDoctor ? 'doctor' : isPeople ? 'people' : '')
                    }
                    key={'dropdown' + idx}>
                    {navItem.name}
                  </button>

                  <div className={'dropdown-content ' + (isDoctor && 'doctor')}>
                    {(navItem.entries || []).map((item, i) => (
                      <NavLink
                        {...NavUtil.getNavLinkExtraProps(navItem)}
                        to={item.path}
                        key={'item' + i}>
                        {item.name}
                      </NavLink>
                    ))}
                  </div>
                </DropDown>
              );
            }

            return (
              <li key={idx}>
                <NavLink
                  {...NavUtil.getNavLinkExtraProps(navItem)}
                  to={navItem.path}
                  className={
                    'nav-item ' +
                    (selected ? ` selected ` : '') +
                    (isDoctor ? 'doctor' : isPeople ? 'people' : '')
                  }>
                  {navItem.name}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>

      <NavBarDrawer
        visible={drawer}
        setVisible={setDrawer}
        navItems={navItems}
        isDoctor={isDoctor}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  background-color: white;
  top: 0px;
  left: 0px;
  width: 100%;
  height: var(--topNavBarHeight);
  // padding: 0px 40px;

  display: flex;
  flex-direction: column;
  // align-items: center;

  z-index: 101;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  & > .container {
    display: flex;
    align-items: center;
    max-width: var(--contentMaxWidth);
    width: 100%;
    margin: 0 auto;
    flex: 1;
    & a {
      color: #666;
      &:hover {
        font-weight: bold;
      }
    }
  }

  & .logo-box {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  & > .sub-nav {
    width: 100%;
    background-color: white;
    & > ul.content {
      list-style: none;
      padding: 0;
      max-width: var(--contentMaxWidth);
      margin: 0 auto;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      & > li {
        flex: 1 0 auto;
        position: relative;
        &:not(:first-child)::before {
          content: '';
          width: 1px;
          display: inline-block;
          position: absolute;
          top: 25%;
          bottom: 25%;
          background-color: rgba(0, 0, 0, 0.2);
        }
      }

      .nav-item {
        display: block;
        width: 100%;
        border: none;
        background-color: transparent;
        cursor: pointer;
        padding: 12px 0;
        text-align: center;
        white-space: nowrap;
      }
    }
  }

  & > .sub-nav.doctor {
    background-color: var(--primaryColor);
    & .nav-item {
      color: white;
    }
  }

  & > .sub-nav.people {
    & > ul.content {
      border-top: 1px solid #ddd;
    }
    & .nav-item {
      color: #000;
      &:hover {
        color: var(--primaryColor);
      }
      &.selected {
        border-top: solid 2px var(--primaryColor);
      }
    }
  }

  & > .container-mobile {
    display: none;
    background-color: var(--primaryColor);
    justify-content: space-between;
    align-items: center;

    & .menu {
      width: var(--topNavBarHeight);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin: 0;
      border: none;
      background: none;
    }
  }

  @media (max-width: ${Theme.maxWidth}px) {
    & > .container,
    > .sub-nav {
      padding: 0 20px;
    }
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & > .container,
    > .sub-nav {
      display: none;
    }
    & > .container-mobile {
      display: flex;
    }
  }
`;

const DropDown = styled.li`
  position: relative;
  display: inline-block;

  & > .dropdown-content {
    position: absolute;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 101;
    background-color: var(--primaryColor);
    min-width: 160px;
    overflow: hidden;

    transition: all 150ms linear 100ms;
    height: 0px;
    opacity: 0;

    & > a {
      display: block;
      padding: 12px 10px;
      color: white;
    }
  }

  & > .dropdown-content.doctor {
    border-top: solid 1px #ffe11b;
  }

  &:hover > .dropdown-content {
    height: auto;
    opacity: 1;

    & > a:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
`;

export default NavBar;
